export default function getInitialValues(props) {
	const { documents, employer } = props
	const signupStatus = employer?.signupStatus || {}
	let missingSections = []
	for (const [section, status] of Object.entries(signupStatus)) {
		if (status?.required && !status?.complete) {
			missingSections.push(section)
		}
	}
	// console.log("missingSections:", missingSections)
	let eligibleIndustryCertification = false
	if (employer?.eligibleIndustryCertificationTs) {
		eligibleIndustryCertification = true
	}
	let missingSectionsString = ""
	if (missingSections?.length > 0) {
		for (const missingSection of missingSections) {
			if (missingSection === "companyInfo") {
				missingSectionsString += "Company Details, "
			} else if (missingSection === "billing") {
				missingSectionsString += "Billing Information, "
			} else if (missingSection === "plans") {
				missingSectionsString += "Plan Selection, "
			} else if (missingSection === "reimbursements") {
				missingSectionsString += "Reimbursement Account, "
			}
		}
		if (missingSectionsString?.length > 0) {
			missingSectionsString = "Please complete the following sections: " + missingSectionsString.slice(0, -2) + "."
		}
	}
	return {
		agreement: !Boolean(documents?.length),
		missingSectionsString: missingSectionsString,
		eligibleIndustryCertification: eligibleIndustryCertification
	}

}